import { useEffect, useState, useMemo } from "react";
import axios from "axios";

import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Tooltip,
  Button
} from "@mui/material";

import { Add, Edit, Trash } from "iconsax-react";

import IconButton from "components/@extended/IconButton";
import SearchBar from "../components/Searchbar";
import PaginationComponent from "../components/Pagination";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const server = process.env.REACT_APP_API_URL;

export default function InformationUpdates() {

  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage] = useState(10);

  const [addModal, setAddModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [title, setTitle] = useState("");
  const [redirectLink, setRedirectLink] = useState("");

  const [editId, setEditId] = useState(null);
  const [deleteId, setDeleteId] = useState(null);

  // ================= GET DATA =================

  const getInformationUpdates = async () => {
    try {
      const res = await axios.get(`${server}/api/marquee`);
      setData(res?.data?.data || []);
    } catch (err) {
      toast.error("Failed to fetch data");
    }
  };

  useEffect(() => {
    getInformationUpdates();
  }, []);

  // ================= SEARCH =================

  const filteredData = useMemo(() => {
    if (!filterText) return data;

    return data.filter((item) =>
      item.title?.toLowerCase().includes(filterText.toLowerCase())
    );
  }, [filterText, data]);

    const handleSearchChange = (event) => {
    setFilterText(event.target.value);
  };
  // ================= PAGINATION =================

  const paginatedData = useMemo(() => {
    const start = page * rowsPerPage;
    return filteredData.slice(start, start + rowsPerPage);
  }, [filteredData, page, rowsPerPage]);

  // ================= OPEN ADD =================

  const handleAddNew = () => {
    setTitle("");
    setRedirectLink("");
    setAddModal(true);
  };

  // ================= ADD =================

  const handleAdd = async () => {
    try {
      await axios.post(`${server}/api/marquee/create`, {
        title,
        redirectLink
      });

      toast.success("Information Added");

      setAddModal(false);
      getInformationUpdates();

    } catch (err) {
      toast.error("Failed to add");
    }
  };

  // ================= EDIT =================

  const openEdit = (row) => {
    setEditModal(true);
    setEditId(row._id);
    setTitle(row.title);
    setRedirectLink(row.redirectLink);
  };

  const handleEdit = async () => {
    try {

      await axios.put(`${server}/api/marquee/update/${editId}`, {
        title,
        redirectLink
      });

      toast.success("Updated Successfully");

      setEditModal(false);
      getInformationUpdates();

    } catch (err) {
      toast.error("Update failed");
    }
  };

  // ================= DELETE =================

  const handleDelete = async () => {
    try {

      await axios.delete(`${server}/api/marquee/${deleteId}`);

      toast.success("Deleted Successfully");

      setDeleteId(null);
      getInformationUpdates();

    } catch (err) {
      toast.error("Delete failed");
    }
  };

  return (
    <>
      <Stack spacing={2}>

        {/* HEADER */}

        {/* <Stack
          direction="row"
          spacing={4}
          justifyContent="space-between"
          alignItems="center"
          sx={{ p: 3, pb: 0 }}
        >

          <SearchBar
            filterText={filterText}
            setFilterText={setFilterText}
          />

          <Button
            variant="contained"
            startIcon={<Add />}
            onClick={handleAddNew}
          >
            Add
          </Button>

        </Stack> */}


         <Stack direction="row" spacing={4} justifyContent="space-between" alignItems="center" sx={{ p: 3, pb: 0 }}>
                  <SearchBar filterText={filterText} setFilterText={setFilterText} handleSearchChange={handleSearchChange} />
        
                  <Stack direction="row" alignItems="center" spacing={3} textAlign="justify">
                    {/* <SortingSelect sortBy={sortBy.id} setSortBy={setSortBy} allColumns={allColumns} /> */}
                    <Button
                      variant="contained"
                      className="bg-blue-500 text-white hover:bg-blue-600"
                      startIcon={<Add />}
                      onClick={handleAddNew}
                      data-modal-toggle="add-modal"
                    >
                      Add
                    </Button>
                  </Stack>
                </Stack>

        {/* TABLE */}

        <Table>

          <TableHead>
            <TableRow>
              <TableCell sx={{ width: "35%" }}>Title</TableCell>
              <TableCell>Redirect Link</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>

            {paginatedData.map((row) => (

              <TableRow key={row._id}>

                <TableCell>
                  <Typography>{row.title}</Typography>
                </TableCell>

                <TableCell>
                  <Typography>{row.redirectLink || "-"}</Typography>
                </TableCell>

                <TableCell>

                  <Tooltip title="Edit">
                    <IconButton onClick={() => openEdit(row)}>
                      <Edit />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title="Delete">
                    <IconButton
                      color="error"
                      onClick={() => setDeleteId(row._id)}
                    >
                      <Trash />
                    </IconButton>
                  </Tooltip>

                </TableCell>

              </TableRow>

            ))}

          </TableBody>

        </Table>

        {/* PAGINATION */}

        <PaginationComponent
          page={page}
          setPage={setPage}
          filteredData={filteredData}
          rowsPerPage={rowsPerPage}
        />

      </Stack>

      {/* ================= ADD MODAL ================= */}

      {addModal && (

        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">

          <div className="bg-white p-6 rounded-lg w-[420px]">

            <div className="flex justify-between mb-4">

              <h3 className="text-xl font-semibold">
                Add Information
              </h3>

              <button onClick={() => setAddModal(false)}>✕</button>

            </div>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleAdd();
              }}
            >

              <div>

                <label className="text-sm font-medium mb-1 block">
                  Title
                </label>

                <input
                  type="text"
                  className="w-full border rounded-lg p-2"
                  placeholder="Enter Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />

              </div>

              <div>

                <label className="text-sm font-medium mb-1 block">
                  Redirect Link
                </label>

                <input
                  type="text"
                  className="w-full border rounded-lg p-2"
                  placeholder="Enter Redirect Link"
                  value={redirectLink}
                  onChange={(e) => setRedirectLink(e.target.value)}
                />

              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
              >
                Save
              </button>

            </form>

          </div>

        </div>

      )}

      {/* ================= EDIT MODAL ================= */}

      {editModal && (

        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">

          <div className="bg-white p-6 rounded-lg w-[420px]">

            <div className="flex justify-between mb-4">

              <h3 className="text-xl font-semibold">
                Edit Information
              </h3>

              <button onClick={() => setEditModal(false)}>✕</button>

            </div>

            <form
              className="space-y-4"
              onSubmit={(e) => {
                e.preventDefault();
                handleEdit();
              }}
            >

              <div>

                <label className="text-sm font-medium mb-1 block">
                  Title
                </label>

                <input
                  type="text"
                  className="w-full border rounded-lg p-2"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  required
                />

              </div>

              <div>

                <label className="text-sm font-medium mb-1 block">
                  Redirect Link
                </label>

                <input
                  type="text"
                  className="w-full border rounded-lg p-2"
                  value={redirectLink}
                  onChange={(e) => setRedirectLink(e.target.value)}
                />

              </div>

              <button
                type="submit"
                className="w-full bg-blue-600 text-white py-2 rounded-lg hover:bg-blue-700"
              >
                Update
              </button>

            </form>

          </div>

        </div>

      )}

      {/* ================= DELETE CONFIRM ================= */}

      {deleteId && (

        // <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">

        //   <div className="bg-white p-6 rounded">

        //     <p>Are you sure you want to delete?</p>

        //     <Stack direction="row" spacing={2} mt={2}>

        //       <Button color="error" onClick={handleDelete}>
        //         Delete
        //       </Button>

        //       <Button onClick={() => setDeleteId(null)}>
        //         Cancel
        //       </Button>

        //     </Stack>

        //   </div>

        // </div>

        
    //   {deleteConfirmation.open && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-md">
            <p className="mb-4">Are you sure you want to delete this record?</p>
            <div className="flex justify-end">
              <button className="bg-red-500 text-white px-4 py-2 rounded-md mr-4" onClick={handleDelete}>
                Confirm
              </button>
              <button
                className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
                onClick={() => setDeleteId(null)}
                // onClick={() => setDeleteConfirmation({ open: false, id: null })}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* )} */}

      <ToastContainer />

    </>
  );
}